import * as yup from 'yup'

function parseRichText(text) {
  if (text === '<p></p>') return ''
  return text
}

const communicationTemplateSchema = yup.object().shape({
  name: yup.string().required('Subject is required'),
  body: yup.string().transform(parseRichText).required('Body is required')
})

const communicationSchema = yup.object().shape({
  name: yup.string().required('Subject is required'),
  body: yup.string().transform(parseRichText).required('Body is required'),
  letterId: yup.string(),
  billId: yup.string()
})

export { communicationTemplateSchema, communicationSchema }
